// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__30O8P","borderless":"style_borderless__1SE04","transparent":"style_transparent__2Vnxu","error":"style_error__DUr_s","overflow":"style_overflow__1x_lP"};